import { Grid } from '@material-ui/core';
import { EntityLayout } from '@backstage/plugin-catalog';
import { EntityOwnershipCard, EntityUserProfileCard } from '@backstage/plugin-org';

import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import { EntityWarningContent } from './EntityWarningContent';

export const UserEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <EntityWarningContent />
        <Grid item xs={12} md={6}>
          <Grid container>
            <Grid item xs={12}>
              <EntityUserProfileCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMarkdownCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container>
            <Grid item xs={12}>
              <EntityOwnershipCard />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
